import { Button as MuiButton, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

const RequestAccessButton = ({ onClick, label }) => {
    const { t } = useTranslation()
    const theme = useTheme()
    return (
        <MuiButton
            size="small"
            sx={{
                minHeight: '31px',
                border: `solid 1px ${theme?.palette?.secondary?.main}`,
                backgroundColor: theme?.palette?.common?.white,
                boxShadow: '0 0 0 0',
                whiteSpace: 'nowrap',
                color: theme?.palette?.secondary?.main,
                textTransform: 'capitalize !important',
                borderRadius: '16px',
                marginRight: `${label ? '5px' : '0px'}`,
                lineHeight: '1.3',
                '&:hover': {
                    backgroundColor: theme?.palette?.secondary?.main,
                    color: 'white',
                    '& span': {
                        color: theme?.palette?.common?.white,
                    },
                },
            }}
            variant="outlined"
            onClick={onClick}
        >
            {label ? label : t('Common_RequestAccess')}
        </MuiButton>
    )
}
export default RequestAccessButton
